import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import {
    TreeSelect, Button, Form, Spin, Modal
} from 'antd';
import moment from 'moment/moment';
import { getLeadsStatusRequest } from '../../redux/actions/get_leads_status.actions';
import { changeLeadsStatusRequest } from '../../redux/actions/change_lead_status.actions';
import { LEAD_STATUS } from '../../../constants/leadStatuses';
import ArrangeCollectionConfirmModal from './ArrangeCollectionConfirmModal';
import { getVal } from '../../../../../shared/helpers';
import { LeadProfileModals } from '../Lead_profile_table/LeadProfileModals';
import { getModalSize } from '../../../utils/getModalSize';

const mapStateToProps = (state) => {
    const { lead_status_list, loading } = state.Leads.Lead_profile.Lead_general;
    const { current_status, root_id, lead_profile } = state.Leads.Lead_profile.Lead_general;
    const { customer_collection_date } = state.Leads.Lead_profile.Ref_lead_customer.customer_details;

    return {
        lead_status_list,
        current_status,
        root_id,
        lead_profile,
        loading,
        customer_collection_date,
        finance_company: getVal(state.Leads, 'Lead_profile.Lead_general.lead_finance.finance_company'),
        finance_expiry_date: getVal(state.Leads, 'Lead_profile.Lead_general.lead_finance.bought_info.finance_expiry_date'),
    };
}; const { TreeNode } = TreeSelect; const
    FormItem = Form.Item;

export default connect(mapStateToProps, null)(class ChangeStatusModal extends PureComponent {
  state = {
      treeSelectValue: this.props.current_status.name,
      isReset: false,
      visible: false,
      cancellationModal: {}
  };

  componentDidMount() {
      this.props.dispatch(getLeadsStatusRequest());
  }

  treeMapStatus = (data) => (
      data.map((status) => (
          !(status instanceof Array) && status.children.length
              ? (
                  <TreeNode value={status._id} title={status.name} key={status._id}>
                      {this.treeMapStatus(status.children)}
                  </TreeNode>
              )
              : <TreeNode value={status._id} title={status.name} key={status._id} />
      ))
  );

  findTreeNode = (data) => (
      data.map((status) => (status.name === this.props.current_status.name ? status : this.findTreeNode(status.children)))
  );

  statusOnChange = (statusValue) => this.setState({ treeSelectValue: statusValue });

  closeArrangeCollectionModal = () => {
      this.setState((prevState) => ({ ...prevState, visible: false }));
  }

  isArrangeCollection = (status) => {
      if (status === LEAD_STATUS.arrangeDelivery || status === LEAD_STATUS.arrangeDeliveryTrade) {
          if (!this.props.customer_collection_date || moment(this.props.customer_collection_date) < moment()) {
              ArrangeCollectionConfirmModal(0, this.closeArrangeCollectionModal);
              return true;
          }
          if (this.props.finance_company !== 'No Finance' && this.props.finance_expiry_date && moment(this.props.customer_collection_date) > moment(this.props.finance_expiry_date)) {
              ArrangeCollectionConfirmModal(1, this.closeArrangeCollectionModal);
              return true;
          }
      }
      return false;
  }

  isCollectionCancelled = (status) => {
      if (status === LEAD_STATUS.collectionCancelled || status === LEAD_STATUS.collectionCancelledTrade) {
        this.setState({ cancellationModal: {
            visible: true,
            popup_type: status === LEAD_STATUS.collectionCancelled ? 'Cancel Collection' : 'Cancel Collection (Trade)',
            status
        }});

          return true;
      }

      return false;
  }

  changeStatus = () => {
      if (!this.isArrangeCollection(this.state.treeSelectValue) && !this.isCollectionCancelled(this.state.treeSelectValue)) {
          this.props.dispatch(changeLeadsStatusRequest(this.props.root_id, this.state.treeSelectValue));
          this.props.closeModal();
      }
  };

  resetStatus = (event) => {
      event.preventDefault();
      this.props.dispatch(getLeadsStatusRequest());
      this.setState({ isReset: true });
  };

  closeCancellationModal = () => {
    this.setState({ cancellationModal: {}});
};

  render() {
      const { lead_status_list } = this.props;
      const filteredStatus = !this.state.isReset ? this.findTreeNode(lead_status_list) : lead_status_list;
      const updatedStatus = filteredStatus.flat(10);
      return (
          <Fragment>
              <p style={{ marginBottom: 20 }}>Override the existing status by selecting from the status list below. Alternatively you can click 'Reset Status' which will giev you access to all statuses in the workflow.</p>
              <Spin spinning={this.props.loading} size="small">
                  <Form>
                      <FormItem style={{ fontStyle: 'italic' }} label="Select Status">
                          {lead_status_list.length
              && (
                  <TreeSelect
                      value={this.state.treeSelectValue}
                      dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                      placeholder="Status"
                      allowClear
                      onChange={this.statusOnChange}
                  >
                      <TreeNode value={undefined} title="Status" key="status1" />
                      {!this.state.isReset ? this.treeMapStatus(updatedStatus) : this.treeMapStatus(lead_status_list)}
                  </TreeSelect>
              )}
                      </FormItem>
                      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                          <Button onClick={this.props.closeModal}>Cancel</Button>
                          <Button onClick={this.resetStatus} icon="redo" style={{ marginLeft: 10 }}>Reset Status</Button>
                          <Button
                              type="primary"
                              icon="edit"
                              style={{ marginLeft: 10 }}
                              onClick={this.changeStatus}
                          >
                              Change Status
                          </Button>
                      </div>
                  </Form>
              </Spin>
              <Modal
                    visible={this.state.cancellationModal.visible}
                    onCancel={this.closeCancellationModal}
                    footer={null}
                    maskClosable={false}
                    width={getModalSize(this.state.cancellationModal.popup_type)}
                    title={this.state.cancellationModal.popup_type}
                >
                    <LeadProfileModals
                        status={this.state.cancellationModal.status}
                        popup_type={this.state.cancellationModal.popup_type}
                        closeModal={this.closeCancellationModal} />
                </Modal>
          </Fragment>
      );
  }
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Modals/ChangeStatusModal.js